import { Link } from 'react-router-dom'
import { SITE } from '../data/site.js'
import Icon from '../components/Icon.jsx'

const STEPS = [
  {
    title: 'Choose your product',
    text: 'Browse Shower Screens, Hardware, 10mm Frameless Glass Panels and Tools & Accessories. Our standard shower screen panel height is 2100mm; the Semi Pro semi-frameless range is H1950. Every glass product is toughened safety glass certified to AS/NZS 2208.',
    link: { to: '/shop', label: 'Browse the shop' },
  },
  {
    title: 'Configure size & finish',
    text: 'On each product page, pick your options step by step — hardware colour (6 finishes) and configuration. The price updates live as you choose, so there are no surprises.',
  },
  {
    title: 'Standard size or custom glass?',
    text: 'Stocked sizes are ready to ship fast. Need a different size? Most frameless screens and panels can be made to measure — contact us first for a quote and lead time. Custom glass requires full payment upfront, we confirm measurements before cutting, and custom items can\'t be returned unless faulty.',
    link: { to: '/contact', label: 'Ask about custom sizes' },
  },
  {
    title: 'Add to cart & checkout',
    text: 'Checkout takes about two minutes — your details, then pickup or delivery. Prices on the site are ex GST; GST (10%) is added and shown clearly before you place the order. Check out as a guest, or create a free account to save your details and track orders.',
    link: { to: '/account', label: 'My account' },
  },
  {
    title: 'Pay by card or bank transfer',
    text: 'Pay by card (Visa, Mastercard, Amex) through Stripe\'s secure checkout — your order is confirmed instantly. Or choose direct bank transfer: you\'ll get our account details with a unique reference (like LU-XXXXXXXX), and we verify transfers usually the same business day.',
  },
  {
    title: 'Pickup or delivery',
    text: `Free pickup from our warehouse at ${SITE.address} (ready in 1–2 business days — we'll contact you when it's ready). Or flat-rate delivery within 50 km of Ravenhall, Victoria only, typically 1–3 business days after dispatch.`,
    link: { to: '/shipping', label: 'Shipping details' },
  },
  {
    title: 'Warranty & returns',
    text: 'Hardware is covered by a 2-year warranty against manufacturing defects. Glass is inspected before it leaves us (size tolerance up to 3mm). Eligible stocked items can be returned within 30 days; custom-made glass can\'t be returned unless faulty.',
  },
]

export default function HowToBuy() {
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>How to Buy</span></nav>
      <header className="page-head">
        <h1>How to buy</h1>
        <p>From browsing to bathroom — buying from Level Up Glass Supply is simple, whether it's a full shower screen or a single seal.</p>
      </header>

      <ol className="howto-list">
        {STEPS.map((s, i) => (
          <li key={s.title} className="howto-step">
            <span className="step-num">{i + 1}</span>
            <div>
              <h2>{s.title}</h2>
              <p>{s.text}</p>
              {s.link && (
                <Link to={s.link.to} className="link-arrow">
                  {s.link.label} <Icon name="arrowRight" size={15} />
                </Link>
              )}
            </div>
          </li>
        ))}
      </ol>

      <div className="contact-card">
        <h2>Not sure where to start?</h2>
        <p>
          Send us photos of your space with rough measurements and we'll recommend the right
          configuration and finish — free, no obligation.
        </p>
        <p><Icon name="phone" size={16} /> <a href={SITE.phoneHref}>{SITE.phone}</a></p>
        <p><Icon name="mail" size={16} /> <a href={`mailto:${SITE.email}`}>{SITE.email}</a></p>
        <Link to="/shop" className="btn btn-primary" style={{ marginTop: 8 }}>Start shopping</Link>
      </div>
    </main>
  )
}
